import { createClient } from "@supabase/supabase-js";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { useState, useEffect, createContext, useContext } from "react";

import { Dashboard } from "./Dashboard.tsx";
import styles from "../styles/Login.module.css";
import getAPIKeys from "./getAPIKeysFromServer";

import Loading from "./LoadingScreen";
import { LanguageContext } from "./App";

export const SupabaseContext = createContext();

function Login() {
  const [session, setSession] = useState(null);
  const [supabase, setSupabase] = useState(null);
  const [language, setLanguage] = useContext(LanguageContext);

  async function createSupabase() {
    const apiKeys = await getAPIKeys();
    const supabaseTemp = createClient(apiKeys.sbUrl, apiKeys.sbApiKey);
    setSupabase(supabaseTemp);

    supabaseTemp.auth.getSession().then(({ data: { session } }) => {
      if (session === null) {
        setSession(false);
      } else {
        setSession(session);
      }
    });

    const {
      data: { subscription },
    } = supabaseTemp.auth.onAuthStateChange((_event, session) => {
      if (session === null) {
        setSession(false);
      } else {
        setSession(session);
      }

      // createUserData(session, supabaseTemp);
    });

    return () => subscription.unsubscribe();
  }

  useEffect(() => {
    createSupabase();
  }, []);

  const variablesRu = {
    sign_in: {
      email_label: "Email",
      password_label: "Пароль",
      button_label: "Войти",
      link_text: "Уже зарегистрированы? Войти!",
      password_input_placeholder: "Пароль",
      email_input_placeholder: "Email",
      loading_button_label: "Входим...",
    },
    sign_up: {
      email_label: "Email",
      password_label: "Пароль",
      button_label: "Создать аккаунт",
      confirmation_text: "Проверьте почту для подтверждения аккаунта",
      link_text: "Нет аккаунта? Создать аккаунт!",
      password_input_placeholder: "Пароль",
      email_input_placeholder: "Email",
      loading_button_label: "Создаем аккаунт...",
    },
    forgotten_password: {
      link_text: "Забыли пароль?",
      email_label: "Email",
      email_input_placeholder: "Email",
      button_label: "Обновить пароль",
      confirmation_text: "Инструкции отправлены вам на почту",
      loading_button_label: "Отправляем...",
    },
  };

  if (supabase === undefined || supabase === null || session === null) {
    return <Loading></Loading>;
  } else {
    return (
      <SupabaseContext.Provider value={supabase}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            backgroundColor: "#fff",
            fontFamily: "Jost",
            fontWeight: 600,
          }}
        >
          {!session ? (
            <div
              style={{
                backgroundColor: "#86efac",
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  boxShadow: "0 0 10px #00000099",
                  width: "90vw",
                  height: "90vh",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className={styles.container}>
                  <h3
                    style={{
                      textAlign: "center",
                      fontSize: 22,
                      fontWeight: 900,
                      marginBottom: 10,
                      color: "#16a34a",
                    }}
                  >
                    eAIq chat Dashboard
                  </h3>
                  <h3
                    style={{
                      textAlign: "center",
                      fontSize: 15,
                      fontWeight: 700,
                      marginTop: 0,
                      fontFamily: "Jost",
                      color: "#000",
                    }}
                  >
                    {language === "en"
                      ? "ChatGPT chatbots for your business"
                      : "Чат-боты с ChatGPT для Вашего Бизнеса"}
                  </h3>
                  <h3
                    style={{
                      textAlign: "center",
                      fontSize: 12,
                      fontWeight: 700,
                      marginTop: 0,
                      fontFamily: "Jost",
                      color: "#000",
                    }}
                  >
                    {language === "en"
                      ? "(and free online chat)"
                      : "(И бесплатный онлайн чат в телеграм)"}
                  </h3>
                  <Auth
                    supabaseClient={supabase}
                    appearance={{
                      theme: ThemeSupa,
                      variables: {
                        default: {
                          colors: {
                            brand: "#16a34a",
                            brandAccent: "#22c55e",
                          },
                          radii: {
                            borderRadiusButton: "8px",
                            buttonBorderRadius: "8px",
                            inputBorderRadius: "8px",
                          },
                        },
                      },
                      style: {
                        anchor: { fontFamily: "Jost", fontWeight: 600 },
                        input: { color: "#000" },
                        button: { color: "#000" },
                      },
                    }}
                    localization={{
                      variables: language === "en" ? null : variablesRu,
                    }}
                    providers={[]}
                  />
                  <a
                    className={styles.whoarewelink}
                    href={
                      language === "en"
                        ? "https://cyberchatai.vercel.app"
                        : "https://cyberchatai.vercel.app?la=ru"
                    }
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "#16a34a",
                    }}
                  >
                    {language === "en" ? "About us" : "Кто мы?"}
                  </a>
                </div>
                <div className={styles.containerSecond}>
                  <h3
                    style={{
                      textAlign: "center",
                      fontSize: 20,
                      fontWeight: 700,
                      marginTop: 0,
                      fontFamily: "Jost",
                      color: "#000",
                    }}
                  >
                    {language === "en"
                      ? `"There’s no doubt that artificial intelligence is the future of customer service" 
                          `
                      : `"Нет сомнений в том, что искусственный интеллект - это будущее обслуживания клиентов" 
                          `}
                  </h3>
                  <h3
                    style={{
                      textAlign: "center",
                      fontSize: 18,
                      fontWeight: 700,
                      marginTop: 0,
                      fontFamily: "Jost",
                      color: "#000",
                      alignSelf: "end",
                    }}
                  >
                    - Blake Morgan {language === "en" ? "from" : "из"} Forbes
                  </h3>
                </div>
              </div>
            </div>
          ) : (
            <Dashboard></Dashboard>
          )}
        </div>
      </SupabaseContext.Provider>
    );
  }
}

export default Login;
